import { DiamondDetailLayout } from '@/features/journal/diamond-detail';

export { getDiamondDetailServerSideProps as getServerSideProps } from '@/features/journal/diamond-page-server';
export default DiamondDetailLayout;
